import React from 'react';
import { useSelector } from 'react-redux';

import { selectEmbeddedMode } from '../store/selectors/ui';

type EmbeddedModeProps = {
  children: React.ReactNode;
  display?: boolean;
  forBuildoutCrm?: boolean;
  forRethink?: boolean;
};

export const RETHINK_MODE = 'rethink';
export const BUILDOUT_CRM_MODE = 'buildoutCrm';
export const EMBEDDED_MODES = [RETHINK_MODE, BUILDOUT_CRM_MODE];

export default function EmbeddedMode(
  { children, display = false, forBuildoutCrm = false, forRethink = false }: EmbeddedModeProps
) {
  const embeddedMode = useSelector(selectEmbeddedMode);
  const inEmbedded = EMBEDDED_MODES.includes(embeddedMode);

  if ((embeddedMode == 'buildoutCrm' && !forBuildoutCrm) || (embeddedMode == 'rethink' && !forRethink)) {
    return null;
  }

  if (inEmbedded && display || (!inEmbedded && !display)) {
    return (
      <>
        {children}
      </>
    );
  }

  return null;
}
